module.exports = __webpack_public_path__ + "img/horloge.83e93d1e.png";